export default __webpack_public_path__ + "media/images/react_icons/property/microwave-96881482931d6d3eda187ce58dd2c6e3.svg";